module.exports = {template: '<svg viewBox="0 0 428.8 428.8"><path class="st0" fill="#fff" stroke="#fff" stroke-width="20" stroke-miterlimit="10" d="M7.1 7.1l414.6 414.6"/><path class="st1" fill="none" stroke="#fff" stroke-width="20" stroke-miterlimit="10" d="M421.7 7.1L7.1 421.7"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cross.svg
// module id = 525
// module chunks = 1